<form [formGroup]="form">
  <div class="row">
    <!-- Type de recrutement field -->
    <div class="col-6 mb-3">
      <div class="row">
        <label class="label col-12 col-form-label" for="typeRecrutement">Type de recrutement@if (this.form.get('typeRecrutement')?.hasValidator(ValidatorsRef.required)) {
          *
        }</label>
        <div class="form-text mb-1">Sélectionnez le type de recrutement (permanent, temporaire...).</div>
        <app-autocomplete-field
          formControlName="typeRecrutement"
          [items]="dataService.typeRecrutementList()"
          [displayFn]="getTypeRecrutementDisplayValue"
          errorMessage="Ce champ est requis">
        </app-autocomplete-field>
      </div>
    </div>

    <!-- Pôle field -->
    <div class="col-6 mb-3">
      <div class="row">
        <label class="label col-12 col-form-label" for="pole">Pôle@if (this.form.get('pole')?.hasValidator(ValidatorsRef.required)) {
          *
        }</label>
        <div class="form-text mb-1">Pôle assigné automatiquement selon votre profil.</div>
        <app-autocomplete-field
          formControlName="pole"
          [items]="dataService.poleList()"
          [displayFn]="getPoleDisplayValue"
          errorMessage="Ce champ est requis">
        </app-autocomplete-field>
      </div>
    </div>

    <!-- Direction field -->
    <div class="col-6 mb-3">
      <div class="row">
        <label class="label col-12 col-form-label" for="direction">Direction@if (this.form.get('direction')?.hasValidator(ValidatorsRef.required)) {
          *
        }</label>
        <div class="form-text mb-1">Sélectionnez la direction.</div>
        <app-autocomplete-field
          formControlName="direction"
          [items]="dataService.directionList()"
          [displayFn]="getDirectionDisplayValue"
          errorMessage="Ce champ est requis">
        </app-autocomplete-field>
      </div>
    </div>

    <!-- Service field -->
    <div class="col-6 mb-3">
      <div class="row">
        <label class="label col-12 col-form-label" for="service">Service ou unité de rattachement@if (this.form.get('service')?.hasValidator(ValidatorsRef.required)) {
          *
        }</label>
        <div class="form-text mb-1">Sélectionnez le service (optionnel).</div>
        <app-autocomplete-field
          formControlName="service"
          [items]="dataService.serviceFonctionnelList()"
          [displayFn]="getServiceDisplayValue"
          [showError]="false">
        </app-autocomplete-field>
      </div>
    </div>

    <!-- Intitulé du poste field -->
    <div class="col-6 mb-3">
      <div class="row">
        <label class="label col-12 col-form-label" for="intitulePoste">Intitulé du poste@if (this.form.get('intitulePoste')?.hasValidator(ValidatorsRef.required)) {
          *
        }</label>
        <div class="form-text mb-1">Sélectionnez l'intitulé du poste.</div>
        <app-autocomplete-field
          formControlName="intitulePoste"
          [items]="dataService.posteList()"
          [displayFn]="getPosteDisplayValue"
          [isLoading]="dataService.isLoadingPostes()"
          [loadingText]="'Chargement des postes...'"
          errorMessage="Ce champ est requis">
        </app-autocomplete-field>
      </div>
    </div>

    <!-- Numéro de poste field -->
    <div class="col-6 mb-3">
      <div class="row">
        <label class="label col-12 col-form-label" for="numPoste">Numéro de poste@if (this.form.get('numPoste')?.hasValidator(ValidatorsRef.required)) {
          *
        }</label>
        <div class="form-text mb-1">Sélectionnez le numéro de poste.</div>
        <app-autocomplete-field
          formControlName="numPoste"
          [items]="dataService.posteList()"
          [displayFn]="getNumeroPosteDisplayValue"
          [filterFn]="filterNumeroPoste"
          [isLoading]="dataService.isLoadingPostes()"
          [loadingText]="'Chargement des postes...'"
          errorMessage="Ce champ est requis">
        </app-autocomplete-field>
      </div>
    </div>

    <!-- Motif de libération field -->
    <div class="col-6 mb-3">
      <div class="row">
        <label class="label col-12 col-form-label" for="motifLiberation">Motif de libération du poste@if (this.form.get('motifLiberation')?.hasValidator(ValidatorsRef.required)) {
          *
        }</label>
        <div class="form-text mb-1">Sélectionnez le motif de libération.</div>
        <app-autocomplete-field
          formControlName="motifLiberation"
          [items]="dataService.motifLiberationList()"
          [displayFn]="getMotifLiberationDisplayValue"
          errorMessage="Le motif de libération est requis.">
        </app-autocomplete-field>
      </div>
    </div>


    <!-- Error state -->
    @if (dataService.hasError()) {
      <div class="col-12">
        <div class="alert alert-warning" role="alert">
          <i class="fas fa-exclamation-triangle"></i>
          {{ dataService.errorMessage() }}
        </div>
      </div>
    }
  </div>
</form>